import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { setValueValue } from '@databases/collab/y-database';
import { FieldType } from '@databases/model/field';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';
import { applyDeltaValue } from '../../utils/apply-delta-value.ts';
import { getConvertedValue } from '../../utils/get-converted-value.ts';
import { getOrSetValue } from '../../utils/get-or-set-value.ts';

export const bulkSetUndefinedValues: YJSChangeHandler<
  DatabaseChangeType.BULK_SET_UNDEFINED_VALUES
> = ({ ydb, change, state }) => {
  ydb.mutate((db) => {
    const delta = change.change;

    if (!delta) {
      return;
    }

    const destType = dbFieldTypeMap[delta.type];

    if (!destType) {
      throw new Error('unsupported type ' + destType);
    }

    // reset all undefined to existing default value
    const valueJSON = db.defaultEntry.toJSON().values[change.fieldId];

    if (valueJSON) {
      for (const entryId of db.entries) {
        const entry = db.entriesById[entryId];

        if (entry && entry.getValue(change.fieldId) === undefined) {
          const value = entry.setValue(change.fieldId, valueJSON.type);

          setValueValue(value, valueJSON);
        }
      }
    } else {
      // set to empty value if no default has been set yet
      for (const entryId of db.entries) {
        const entry = db.entriesById[entryId];

        if (entry && entry.getValue(change.fieldId) === undefined) {
          const value = entry.setValue(change.fieldId, FieldType.Text);

          setValueValue(value, {
            type: FieldType.Text,
            value: { plain: '' }
          });
        }
      }
    }

    // update default entry
    const convertedValue = getConvertedValue(
      ydb,
      change.fieldId,
      ydb.defaultEntry.getValue(change.fieldId),
      destType,
      state
    );

    applyDeltaValue(
      (destType) =>
        getOrSetValue(db.defaultEntry, change.fieldId, destType, convertedValue),
      delta
    );
  });
};
